import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'containers/misc'
import { Title, Form } from 'components/layout'
import { Button } from 'components/misc'
import { form } from 'helpers/decorators'
import { injectIntl, FormattedMessage } from 'react-intl'


@form({
    form: 'delete-participant-award-approval-modal',
    disableHook: true
})
@injectIntl
class DeleteParticipantAwardApprovalModal extends Component {
    static propTypes = {
        handleSubmit: PropTypes.func,
        modalId: PropTypes.string,
        modal: PropTypes.func,
        isLoading: PropTypes.bool,
        participantId: PropTypes.number.isRequired,
        participantName: PropTypes.string.isRequired,
        awardLevel: PropTypes.string.isRequired,
        onApprove: PropTypes.func.isRequired
    }

    getModalDefaultMessage () {
        return 'You are about to erase award level. This is irreversible. ' +
            'Rules: ' +
            'a) participant needs to have more than awards. ' +
            'b) major activity will reset in case it was required on the award level you are about to delete. ' +
            'c) if two awards remain after deletion then major activity will be set on the lower one, only case it is not in award auth/completed/ceremony state.'
    }

    render() {
        const {
            modalId,
            modal,
            handleSubmit,
            participantId,
            participantName,
            awardLevel,
            isLoading,
            onApprove
        } = this.props

        return (
            <Modal id={modalId} modal={modal} customActions>
                <Title h2 intlKey="moduleTitle.award_participant_delete">
                    Delete participant award
                </Title>
                <Form
                    className="form"
                    onSubmit={handleSubmit((onApprove))}
                >
                    <div className="row">
                        <div className="col-xs-12" style={{ marginBottom: '15px' }}>
                            <FormattedMessage
                                id="label.delete_participant_award_info"
                                defaultMessage={this.getModalDefaultMessage()}
                            />
                            <br /><br />
                            <p style={{ fontWeight: 'bold' }}>
                                <FormattedMessage
                                    id="label.delete_participant_award_modal_question_detail"
                                    defaultMessage='Are you sure want to delete {awardLevel} award for participant {participantId} - {participantName}.'
                                    values={{
                                        participantId,
                                        awardLevel,
                                        participantName
                                    }}
                                />
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-6">
                            <Button
                                intlKey="button.dismiss"
                                onClick={() => this.props.modal(null)}
                                secondary
                                type="button"
                                style={{ marginRight: 10 }}
                            >
                                Dismiss
                            </Button>
                        </div>
                        <div className="col-xs-6 text--right">
                            <Button
                                isLoading={isLoading ? true : undefined}
                                intlKey="button.approve"
                                type="submit"
                            >
                                Approve
                            </Button>
                        </div>
                    </div>
                </Form>
            </Modal>
        )
    }
}

export default DeleteParticipantAwardApprovalModal
